export enum FormMode {
    UPDATE = "update",
    CREATE = "create"
}